import React from "react";
import { BrowserRouter } from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import MainPage from "./page/main_page/main_page";
import IntroPage from "./page/intro_page/intro_page";
import RoutesSetup from "./routes/route_setup";

function App() {
  return (
    <BrowserRouter>
      <RoutesSetup />
    </BrowserRouter>
  );
}

export default App;
